// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dBWx","rootNoMargin":"styles_rootNoMargin__1vhPM"};